import React from 'react';
import { Link } from 'gatsby';

export default ({to, className, children}) => {
    return (
        <li className={`nav-item ${className}`}>
            <Link className="nav-link" to={to}>
                <span className="icon-hold">
                    <span className="ball"></span>
                    <span className="shadow"></span>
                </span>
                <span className="txt">{children}</span>
            </Link>
        </li>
    );
};
  
